import { get, post } from '@/utils/apiBase.js'

//获取小红书活动详情
const getRedNoteDetail = option => {
  return get('/apis/activity/rednote/draw_info', option)
}

//获取抽奖活动详情 
const getDrawInfoDetail = option => {
  return get('/apis/activity/draw_info', option)
}

//获取助力活动详情
const getAssistDetail = option => {
  return get('/apis/activity/get_draw_share_info', option)
}

//为TA助力
const assistUserActivity = option => {
  return post('/apis/activity/assist_user_activity', option)
}

//获取提报活动列表
const getSubmitList = option => {
  return get('/apis/activity/pta_list', option)
}

//获取用户积分
const getUserIntegral = option => {
  return get('/apis/vip/integral/home/detail', option)
}

//获取提报活动详情
const getSubmitDetail = option => {
  return get('/apis/activity/submitable_activity_info', option)
}

export default {
  getUserIntegral,
  getRedNoteDetail,
  getAssistDetail,
  assistUserActivity,
  getDrawInfoDetail,
  getSubmitList,
  getSubmitDetail
}
